import { Slot } from 'app/routx-router'
import AuthenticatedLayout from 'app/src/layouts/AuthenticatedLayout'
import MenuLayout from 'app/src/layouts/MenuLayout'
import ProtectedRoute from 'app/src/layouts/ProtectedRoute'

const HelpLayout: FC = () => {
  return (
    <ProtectedRoute>
      <AuthenticatedLayout>
        <MenuLayout>
          <Slot />
        </MenuLayout>
      </AuthenticatedLayout>
    </ProtectedRoute>
  )
}
export const Component = HelpLayout
export default HelpLayout
